<template>
  <div class="container">
    <div class="img">
      <img src="./img/back.4722257873f.jpg" alt="" />

    </div>

    <div class="zou"  >
      <div class="han">产品与服务</div>
      <div class="ying">
        Product And <br />
        Service
      </div>
    </div>

    <div class="dao2" >
      <div style="width: 5.5313vw;"> <router-link :to="{name:'first'}" >
        <span :class="{active:active=='first'}" @click="active='first'">产品中心</span>
      </router-link></div>
      <div style="width: 8.5313vw;"> <router-link :to="{name:'second'}">
        <span :class="{active:active=='second'}" @click="active='second'">PTT养猪学习院</span>
      </router-link></div>
        <div style="width: 8.5313vw;"> <router-link :to="{name:'third'}">
          <span :class="{active:active=='third'}" @click="active='third'">PSY应用研究院</span>
        </router-link></div>
          <div style="width: 11.5313vw;"> <router-link :to="{name:'fourth'}">
            <span :class="{active:active=='fourth'}" @click="active='fourth'">1+3精益生产咨询项目</span>
          </router-link></div>
            <!-- <div> <router-link :to="{name:'fifth'}">
              <span :class="{active:active=='fifth'}" @click="active='fifth'">产业服务</span>
            </router-link></div> -->
    </div>
    <div class="xian"></div>

  </div>
</template>

<script>
  export default {
    name: "Index",
    data(){
      return{
        active:''
      }
    },
    watch:{
      $route:{
        deep:true,
        immediate:true,
        handler(newV,olV) {
          console.log(this.active)
          this.active = newV.name;
          console.log(newV,"hello大家好")
          console.log(this.active,"??????")
        }
      }
    }
  }
</script>

<style scoped>
  .img img {
    width: 100%;
    height: 48.6891vh;
  }
  .zou{
    width: 11.1979vw;
    height: 12.9551vh;
    opacity: 0.8;
    background-color: #1EA364;
    position: absolute;
    margin-left: 5.5625vw;
    margin-top: -8.633vh;
  }
  .han{
    width: 10.7083vw;
    height: 1.4063vw;
    font-size: 1.5625vw;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 700;
    text-align: left;
    color: #ffffff;
    margin-top:0.6771vw ;
    margin-left: 0.8854vw;
  }
  .ying{
    width: 18.125vw;
    height: 1.1979vw;
    font-size: 1.3vw;
    font-family: PingFang SC, PingFang SC-Light;
    font-weight: 300;
    text-align: left;
    color: #ffffff;
    margin-left: 0.8854vw;
    margin-top: 0.8vw;
  }

  .dao2{
    height:3.5937vw;
    margin-left: 33vw;
    line-height: 3.5937vw;
    display: flex;
  }
  .dao2 div{
    height: 1.0938vw;
    font-size: 1.1458vw;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #949090;
    /* padding-left: 2.0833vw; */
    padding-right: 2.0833vw;
    padding-bottom: 1.0417vw;
  }
  .dao2 div span{
    padding-bottom: 1.0417vw;
  }
  .xian{
    width: 93.0200vw;
    height: 0.0529vw;
    opacity: 0.6;
    background-color: #A2A2A2;
    margin-left: 3.4896vw;

  }
  span:hover{
    color: #1EA364;
    border-bottom: 0.15vw solid #1EA364;
  }

  .active{
    color: #1EA364;
    border-bottom: 0.15vw solid #1EA364;
  }
</style>